import { CurrentAppComponents, AppComponent as IAppComponent } from '../../interfaces/appcomponent';
import { AppModule } from './AppModule';
import { Descriptor } from '../../interfaces/appmodule';
import { EntityDefinition } from '@definitions/EntityDefinition';

export class AppComponents {
    private static _appComponents: IAppComponent[];
    private static _descriptor: Descriptor;
    public static async loadAsync(): Promise<void> {
        if (!this._appComponents) {
            const appModule = AppModule.get();
            this._descriptor = appModule.descriptor;

            const appComponents: IAppComponent[] = [];
            const entityNames: string[] = [];

            for (const appComponent of this._descriptor.appInfo.Components) {
                if (appComponent.Type === 1) {
                    const logicalName = this._descriptor.appInfo.AppComponents.Entities.find(x => x.Id === appComponent.Id)?.LogicalName;
                    if (!logicalName) {
                        console.warn(`Logical name for entity component with Id ${appComponent.Id} not found in descriptor.`);
                    }
                    appComponents.push({
                        componenttype: 1,
                        objectid: appComponent.Id,
                        appmodulecomponentid: null,
                        componentlogicalname: logicalName
                    });
                    entityNames.push(logicalName);
                }
                else {
                    appComponents.push({
                        componenttype: appComponent.Type,
                        objectid: appComponent.Id,
                        appmodulecomponentid: null,
                        componentlogicalname: appComponent.EntityName
                    });
                }
            }

            EntityDefinition.preloadAsync(entityNames);

            this._appComponents = appComponents;
        }
    }

    public static get(): IAppComponent[] {
        if (!this._appComponents) {
            throw new Error("AppComponents is unitialized!");
        }
        return this._appComponents;
    }
    public static async filterAppComponents(entityName: string, componentType: number): Promise<string[]> {
        const appComponents = this.get();
        const filteredAppComponents = appComponents.filter(x => x.componenttype === componentType && x.componentlogicalname == entityName);
        return filteredAppComponents.map(x => x.objectid);
    }

    public static getCurrentAppComponents(): CurrentAppComponents {
        return {
            entities: this._descriptor.appInfo.AppComponents.Entities
        };
    }
}